"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const AdAnalyticsVideoIndexKeyFrame_1 = require("./AdAnalyticsVideoIndexKeyFrame");
const AdAnalyticsVideoIndexKeyword_1 = require("./AdAnalyticsVideoIndexKeyword");
const AdAnalyticsVideoIndexWatchingRating_1 = require("./AdAnalyticsVideoIndexWatchingRating");
class AdAnalyticsVideoIndex {
    constructor({ keywords, keyFrames, watchingRatings, }) {
        this.toJSON = () => ({
            keywords: this.keywords.toJSON(),
            keyFrames: this.keyFrames.toJSON(),
            watchingRatings: this.watchingRatings.toJSON(),
        });
        this.keywords = keywords;
        this.keyFrames = keyFrames;
        this.watchingRatings = watchingRatings;
    }
}
AdAnalyticsVideoIndex.fromJSON = (json) => {
    const { keywords, keyFrames, watchingRatings } = Object.assign({}, json);
    if (!Array.isArray(keywords))
        throw new Error('.keywords must be an array');
    if (!Array.isArray(keyFrames))
        throw new Error('.keyFrames must be an array');
    if (!Array.isArray(watchingRatings))
        throw new Error('.watchingRatings must be an array');
    const _keywords = immutable_1.List(keywords).map((item) => AdAnalyticsVideoIndexKeyword_1.default.fromJSON(item));
    const _keyFrames = immutable_1.List(keyFrames).map((item) => AdAnalyticsVideoIndexKeyFrame_1.default.fromJSON(item));
    const _watchingRatings = immutable_1.List(watchingRatings).map((item) => AdAnalyticsVideoIndexWatchingRating_1.default.fromJSON(item));
    return new AdAnalyticsVideoIndex({
        keywords: _keywords,
        keyFrames: _keyFrames,
        watchingRatings: _watchingRatings,
    });
};
exports.default = AdAnalyticsVideoIndex;
